import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import CashoutProcessButton from "./cashout/CashoutProcessButton";
import CashoutConfirmationForm from "./cashout/CashoutConfirmationForm";
import CashoutMessageModal from "./cashout/CashoutMessageModal";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";

export default observer(function BetItemCashout() {
	const myBetsStore = useContext(MyBetsStoreContext);

	const bet = useContext(MyBetsBetContext);

	if (!myBetsStore) {
		return null;
	}

	if (bet.isCashoutUnavailable) {
		return null;
	}

	if (
		myBetsStore instanceof MyBetsStore &&
		myBetsStore.betDetailsModalStore.isModalOpen
	) {
		return null;
	}

	if (
		myBetsStore.cashoutStore.isCashoutModalOpen &&
		myBetsStore.cashoutStore.cashoutModalData?.id === bet.id
	) {
		if (myBetsStore.cashoutStore.cashoutModalData?.message != null) {
			return <CashoutMessageModal store={myBetsStore} />;
		}
		return <CashoutConfirmationForm store={myBetsStore} />;
	}

	return <CashoutProcessButton store={myBetsStore} />;
});
